import { definePreset, palette } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const customPreset = definePreset(Aura, {
    semantic: {
        primary: palette('#8ccd0f'),
    },
});

export const PAX_THEME = {
    preset: customPreset,
    prefix: 'p',
    options: {
        darkModeSelector: false,
    },
    cssLayer: {
        name: 'primeng',
        order: 'tailwind-base, primeng, tailwind-utilities',
    },
};
